<template>
  <div class="trip-item rounded-box">
    <article class="absolute top-0 left-0 size-full">
      <component
        :is="parent.component"
        class="size-full block"
        v-bind="parent.props"
        :aria-label="title"
      >
        <ResponsiveImage
          class="article-block-img flex flex-col h-full"
          :image="image"
          :alt="title"
          :type="imageType"
        >
          <div
            v-if="title"
            class="size-full flex flex-col justify-center"
          >
            <h4 class="m-0 text-center text-white drop-shadow-dark">
              {{ title }}
            </h4>
          </div>
          <slot />
        </ResponsiveImage>
      </component>
    </article>
  </div>
</template>

<script>
import { NuxtLink } from '#components'

export default defineNuxtComponent({
  components: {
    NuxtLink,
  },

  props: {
    title: {
      type: String,
      default: '',
    },

    link: {
      type: String,
      default: null,
    },

    image: {
      type: String,
      default: '',
    },

    imageType: {
      type: String,
      default: 'cloudinary',
    },
  },

  computed: {
    parent () {
      if (this.link) {
        return {
          component: NuxtLink,
          props: { to: this.link },
        }
      }
      return {
        component: 'div',
        props: { },
      }
    },
  },
})
</script>
